<div class="prepaid-wash-books">
  <div class="prepaid-wash-books__cards">
    <app-package-cards
      [title]="'Total Packages'"
      [count]="totalCountDisplay"
      [cardClass]="'card-1'"
      [image]="packageImage"
    />
    <app-package-cards
      [title]="'Active Packages'"
      [count]="activeCountDisplay"
      [cardClass]="'card-2'"
      [image]="packageImage2"
    />
    <app-package-cards
      [title]="'Inactive Packages'"
      [count]="inactiveCountDisplay"
      [cardClass]="'card-3'"
      [image]="packageImage3"
    />
    <app-package-cards
      [title]="'Redeemed'"
      [count]="redeemedCountDisplay"
      [cardClass]="'card-2'"
      [image]="redeemedImage"
    />
  </div>

  <div class="package-filters-container prepaid-wash-books__filters">
    <div class="search-bar">
      <img src="assets/images/package/search.svg" alt="" />
      <input
        type="text"
        placeholder="Search for packages.."
        [ngModel]="searchTerm"
        (ngModelChange)="onSearchChange($event)"
        aria-label="Search prepaid wash books"
      />
      @if (searchTerm) {
        <button
          type="button"
          class="clear-search"
          (click)="clearSearch()"
          aria-label="Clear search"
        >
          ×
        </button>
      }
    </div>
    <div class="actions-container">
      <div class="prepaid-status-filters" role="group" aria-label="Status filter">
        <button
          type="button"
          class="prepaid-status-filters__btn"
          [class.prepaid-status-filters__btn--active]="statusFilter === 'all'"
          (click)="onStatusFilterChange('all')"
        >
          All
        </button>
        <button
          type="button"
          class="prepaid-status-filters__btn"
          [class.prepaid-status-filters__btn--active]="statusFilter === 'active'"
          (click)="onStatusFilterChange('active')"
        >
          Active
        </button>
        <button
          type="button"
          class="prepaid-status-filters__btn"
          [class.prepaid-status-filters__btn--active]="statusFilter === 'inactive'"
          (click)="onStatusFilterChange('inactive')"
        >
          Inactive
        </button>
      </div>
    </div>
  </div>

  @if (loading) {
    <app-loading-table-shimmer
      [columns]="shimmerColumns"
      [rows]="itemsPerPage"
      [showHeader]="true"
      className="prepaid-wash-books-shimmer"
    />
  } @else if (books.length === 0) {
    <p class="prepaid-wash-books__empty p5" role="status">
      @if (searchTerm.trim()) {
        No prepaid wash books match your search.
      } @else {
        No prepaid wash books yet.
      }
    </p>
  } @else {
    <app-prepaid-wash-books-table
      [books]="books"
      [loading]="loading"
      (deleted)="onBookDeleted()"
      (edit)="onEditBook($event)"
    />
  }

  @if (!loading && totalItems > 0) {
    <app-pagination-bar
      [paginationData]="paginationData"
      [itemsPerPageOptions]="[10, 25, 50]"
      (pageChange)="onPageChange($event)"
      (itemsPerPageChange)="onItemsPerPageChange($event)"
    />
  }
</div>
